// removed by extract-text-webpack-plugin
module.exports = {"Auth":"Auth__Auth__2YUr1","Title":"Auth__Title__96lKt","LinkToTerms":"Auth__LinkToTerms__PaBXD","LogoBox":"Auth__LogoBox__2tqcn","fadeIn":"Auth__fadeIn__2ECGk","LoginBtns":"Auth__LoginBtns__FPFRk","BackBtn":"Auth__BackBtn__2c-zk","Loading":"Auth__Loading__emj8f","yurayura":"Auth__yurayura__3EAYm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 368
// module chunks = 0